// Public UI adapted from Klargo-Reference/components/layout/Footer.tsx.
import DsLogo from '../ds/DsLogo.jsx';
import { useLanguage } from './LanguageSwitcher.jsx';
const footerLink = 'inline-flex min-h-[44px] items-center -mx-1 rounded px-1 text-[rgba(233,237,238,.72)] transition-colors hover:text-white hover:underline underline-offset-4 lg:min-h-0 lg:py-1';
const FOLD_GROUNDS = {
    sheet: { top: '#FFFFFF', shade: '#F1F4F5' },
    canvas: { top: '#F7FAF8', shade: '#F0F4F1' },
};
const Footer = ({ ground = 'sheet' }) => {
    const fold = FOLD_GROUNDS[ground];
    const { t } = useLanguage();
    return (<footer id="footer" role="contentinfo" className="ds-footer relative overflow-hidden bg-ds-ink pb-12 font-ds-sans text-[14px] leading-[1.55] text-ds-ink-on-soft">
      
      <svg className="ds-footer-fold pointer-events-none absolute left-0 top-[-1px] w-full" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
        <defs>
          <linearGradient id="klargo-footer-fold" x1="0" y1="0" x2="0.5" y2="1">
            <stop offset="0" stopColor={fold.top}/>
            <stop offset="0.42" stopColor={fold.top}/>
            <stop offset="0.8" stopColor={fold.shade}/>
          </linearGradient>
        </defs>
        <polygon points="-1,0 101,0 101,50 -1,100" fill="url(#klargo-footer-fold)"/>
      </svg>

      <div className="relative z-10 mx-auto max-w-[1200px] px-6 pt-12 md:px-8">
        
        
        
        <div className="mb-12 grid gap-x-10 gap-y-9 md:grid-cols-2 lg:grid-cols-4 lg:gap-y-10">
          
          <div>
            <div className="mb-4 flex items-center gap-2">
              <DsLogo tone="onInk"/>
            </div>
            <p className="m-0 max-w-[26ch] text-[13.5px] text-[rgba(233,237,238,.66)]">
              {t('footer.tagline')}
            </p>
            
            <a href="https://www.linkedin.com/company/klargo" target="_blank" rel="noopener noreferrer" className={`mt-1 gap-2 ${footerLink}`}>
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
              LinkedIn
            </a>
          </div>

          
          <div>
            <h4 className="mb-2 font-ds-sans text-[12.5px] font-semibold uppercase tracking-[0.06em] text-[rgba(233,237,238,.55)] md:mb-4">
              {t('footer.help.title')}
            </h4>
            <ul className="m-0 list-none p-0 md:space-y-2">
              <li>
                <a href="/hjalp" className={footerLink}>
                  {t('nav.publicHelp')}
                </a>
              </li>
              
              <li>
                <a href="/sakerhet-och-bedragerier" className={footerLink}>
                  {t('footer.security')}
                </a>
              </li>
            </ul>
          </div>

          
          <div>
            <h4 className="mb-2 font-ds-sans text-[12.5px] font-semibold uppercase tracking-[0.06em] text-[rgba(233,237,238,.55)] md:mb-4">
              {t('footer.legal.title')}
            </h4>
            <ul className="m-0 list-none p-0 md:space-y-2">
              <li>
                <a href="/integritet" className={footerLink}>
                  {t('footer.legal.privacy')}
                </a>
              </li>
              <li>
                <a href="/villkor" className={footerLink}>
                  {t('footer.legal.terms')}
                </a>
              </li>
              <li>
                <a href="/cookies" className={footerLink}>
                  {t('footer.legal.cookies')}
                </a>
              </li>
            </ul>
          </div>

          
          <div>
            <h4 className="mb-2 font-ds-sans text-[12.5px] font-semibold uppercase tracking-[0.06em] text-[rgba(233,237,238,.55)] md:mb-4">
              {t('footer.contact.title')}
            </h4>
            <a href="mailto:support@klargo.se" className={footerLink}>
              support@klargo.se
            </a>
            <p className="m-0 text-[13.5px] text-[rgba(233,237,238,.6)] lg:mt-1">
              {t('ds.support.contactHours')}
            </p>
          </div>
        </div>

        <div className="border-t border-[rgba(247,249,249,.16)] pt-7">
          <p className="m-0 text-center text-[13px] text-[rgba(233,237,238,.6)]">
            © {new Date().getFullYear()} Klargo Technologies AB • Org.nr 559571-7736 • Stockholm
          </p>
        </div>
      </div>
    </footer>);
};
export default Footer;
